import { render, staticRenderFns } from "./SrsReport.vue?vue&type=template&id=66881735&scoped=true&"
import script from "./SrsReport.vue?vue&type=script&lang=ts&"
export * from "./SrsReport.vue?vue&type=script&lang=ts&"
import style0 from "./SrsReport.vue?vue&type=style&index=0&id=66881735&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66881735",
  null
  
)

export default component.exports